// src/utils/apiError.js
//
// ASP.NET Core's default [ApiController] model-validation response looks like:
//   { title: "One or more validation errors occurred.", errors: { EndDate: ["..."] } }
// Most of this app's services only ever surfaced `title` (or a generic
// fallback string), so real failures showed up to users/admins as the
// meaningless "One or more validation errors occurred." banner with no way
// to tell what actually went wrong. This pulls out the real reason (and,
// when the API sent per-field validation messages, keeps those separately
// so a form can highlight the right field) instead of the generic wrapper.
export function parseApiError(error, fallback = 'Something went wrong. Please try again.') {
  const data = error?.response?.data;
  let fieldErrors = null;
  let message = null;

  if (data && typeof data === 'object') {
    // ValidationProblemDetails: { errors: { FieldName: ["message", ...] } }
    if (data.errors && typeof data.errors === 'object' && Object.keys(data.errors).length) {
      fieldErrors = data.errors;
      const lines = Object.entries(data.errors).flatMap(([field, msgs]) =>
        (Array.isArray(msgs) ? msgs : [msgs]).map((m) => `${field}: ${m}`)
      );
      if (lines.length) message = lines.join(' ');
    }

    if (!message) {
      message = data.detail || data.message || null;
    }

    // Only fall back to the generic ProblemDetails title if nothing more
    // specific was available.
    if (!message && data.title) message = data.title;
  } else if (typeof data === 'string' && data.trim()) {
    message = data;
  }

  if (!message) message = error?.message;

  const parsed = new Error(message || fallback);
  parsed.fieldErrors = fieldErrors;
  parsed.original = error;
  return parsed;
}
